import React, { Component } from 'react';

class CustomAudioPlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageLoaded: false
        };
    }

    handleImageLoad = () => {
        this.setState({ imageLoaded: true });
    }

    render() {
        const { src, title, poster } = this.props;
        const { imageLoaded } = this.state;
        return (
            <div style={{ 
                width: '100%',
                margin: '0 auto',
                borderRadius: 8,
                overflow: 'hidden',
                background: '#f5f5f5',
                padding: '10px'
            }}>
                {poster && (
                    <div style={{
                        width: '100%',
                        aspectRatio: '16/9',
                        marginBottom: '10px',
                        borderRadius: '4px',
                        overflow: 'hidden',
                        background: '#222',
                        position: 'relative',
                        minHeight: '180px'
                    }}>
                        <img
                            src={poster}
                            alt="Thumbnail"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                opacity: imageLoaded ? 1 : 0,
                                transition: 'opacity 0.3s ease'
                            }}
                            onLoad={this.handleImageLoad}
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                        {!imageLoaded && (
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: '#222'
                            }}>
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    border: '3px solid #f3f3f3',
                                    borderTop: '3px solid #3498db',
                                    borderRadius: '50%',
                                    animation: 'spin 1s linear infinite'
                                }} />
                            </div>
                        )}
                    </div>
                )}
                {title && (
                    <div style={{
                        marginBottom: '8px',
                        fontWeight: 500,
                        fontSize: '1rem'
                    }}>
                        {title}
                    </div>
                )}
                { src !== null && src !== "" &&
                    (
                        <audio
                        controls
                        style={{
                            width: '100%',
                            height: '40px'
                        }}
                        onPlay={this.props.onPlay}
                        onPause={this.props.onPause}
                        >
                            <source src={src} type="audio/mpeg" />
                            Trình duyệt của bạn không hỗ trợ thẻ audio.
                        </audio>
                    )
                }
                <style>
                    {`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}
                </style>
            </div>
        );
    }
}

export default CustomAudioPlayer;
